// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link[data-v-1ba8d3be],.text[data-v-1ba8d3be]{margin-bottom:16px}.link[data-v-1ba8d3be]{display:flex;font-size:12px}.link .el-button[data-v-1ba8d3be]{margin:-4px 0 0 16px;height:27px}.name[data-v-1ba8d3be]{margin-bottom:8px}.title[data-v-1ba8d3be]{margin-bottom:10px}.grey-box[data-v-1ba8d3be]{padding:10px;border-radius:4px;background-color:#f9f9f9}", ""]);
// Exports
module.exports = exports;
